module.exports = {
  CopyMonthSetting: 'Настройка CopyMonth',
  FinanceSetting: 'Настройка финансовых данных',
  HrSetting: 'Настройка данных HR',
  MonthlyDataArchive: 'Архив месячных данных',
  MonthlyFinance: 'Фиксированная дата месяца (финансы)',
  MonthlyHr: 'Фиксированная дата месяца (HR)',
  MonthDataArchive: 'Архив данных середины месяца',
  WeeklyDay: 'Еженедельно',
  SetJudgmentCriteria: 'Настройка условий определения различий',
  ExportingData: 'Идет экспорт данных...',
  ExportActualAmountData: 'Экспорт данных списания Accpac',
  ExportInvoiceData: 'Экспорт данных счетов Accpac',
  ExportBillingData: 'Экспорт данных зарубежных счетов Accpac',
  SelectDataWithInvoiceNumber: 'Пожалуйста, выберите данные с номерами счетов.',
  SelectDataWithBillingNumber: 'Пожалуйста, выберите данные с номерами квитанций.'
}
